module.exports = __webpack_public_path__ + "static/assets/47f6f4c117142e4ba61be356ab6c2a1e.svg";